import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function BridgeportPage() {
  const location = getLocationById('bridgeport');
  if (!location) {
    return <div data-id="element-778">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-779">
      <Header data-id="element-780" />

      <main className="pt-20" data-id="element-781">
        <LocationPageHero location={location} data-id="element-782" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-783" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-784" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-785" />
      </main>

      <Footer data-id="element-786" />
    </div>;
}